var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box text-center size-px-24 pa-50"},[_vm._v(" 준비중입니다 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }